// extracted by mini-css-extract-plugin
export var background = "background-module--background--aa98b";
export var backgroundVariantA = "background-module--backgroundVariantA--c8a16";
export var backgroundVariantB = "background-module--backgroundVariantB--097b2";
export var backgroundVariantC = "background-module--backgroundVariantC--d3201";
export var backgroundVariantD = "background-module--backgroundVariantD--e35cc";
export var backgroundVariantE = "background-module--backgroundVariantE--73184";
export var backgroundVariantF = "background-module--backgroundVariantF--62f93";
export var backgroundVariantGrey = "background-module--backgroundVariantGrey--16eaf";
export var backgroundVariantWhite = "background-module--backgroundVariantWhite--78811";
export var backgroundVariantZ = "background-module--backgroundVariantZ--cb866";